import { render } from "./subtareaList.vue?vue&type=template&id=8c3a6204"
import script from "./subtareaList.vue?vue&type=script&lang=js"
export * from "./subtareaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__